import { CreateShiftAutomationForm } from '@/services/Calendar/ShiftAutomation/forms/CreateShiftAutomationForm';

export class EditShiftAutomationForm extends CreateShiftAutomationForm {
}
